import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { ItemDetails } from 'src/app/models/item-details';

@Injectable()
export class ItemDetailsService {
  constructor(private http: ApiClient) {}

  public get(id: number) {
    return this.http.get<ItemDetails>(`items/${id}/summary`);
  }
}
